/* eslint-disable react-hooks/rules-of-hooks */
import {Box} from '@mui/material';
import * as Types from 'graphql/types';
import {GetServerSidePropsContext} from 'next';
import ErrorPage from 'next/error';
import {useRouter} from 'next/router';
import {useEffect, useMemo} from 'react';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import RenderNextImage from '~/components/wrapper/atoms/render-next-image';
import {handleReturnDateForLocal} from '~/components/wrapper/organisms/scrolling-thumbnail-card/scrolling-thumbnail-card';
import {PLACEHOLDER_IMG} from '~/constants';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {usePageSetting} from '~/providers/page-context.provider';
import {
  handleConvertToLocaleContentful,
  handleReturnIDVideo,
  handleReturnImg,
  handleReturnTypeVideo,
  handleTranslateGameGenres,
  handleTranslateGameLanauges,
  handleTranslateNews,
} from '~/utils';
import {getGloablByType} from '~/utils/global-operations';
import Page, {getPageData} from '../../[[...slug]]/index.page';
// import getPriceGame from '../games-graphql';
import getDataRefBySlug, {PAGE_TYPE} from 'utils/get-data-ref-by-slug';
import getListNews from './get-news-by-tag';
import {GetGamesQueryDetailQuery} from '~/graphql/typescript-operations.generated';
import {client} from '~/utils/contentfulHelper';
import {handleGetProductDetail} from './get-product-detail';
import getListOtherGamesLanguages from './get-other-games-languages';

const GamesDetail = (props: any) => {
  const {
    locale,
    detailData,
    listPatchNotes,
    listUpdateBarNews,
    listLatestNews,
    // listNewsDLCcard,
    listFreeCollectibles,
    dataAdsContainer,
    dataPoliciesAndNotes,
    bcProductReference,
    listSubNavigationBar,
    // codeProductReference,
    entryData,
    orderGames,
  } = props;
  const detailItem = detailData?.data?.gameCollection?.items[0];

  const router = useRouter();
  const {globalData, setDataSlug} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const listTagsColor = globalData?.listTagsColor ?? [];

  if (!detailItem) {
    return <ErrorPage statusCode={404} />;
  }
  const id = router.query?.id || null;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (id && id !== 'null') {
        setTimeout(() => {
          const itemView = document.getElementById(`${id}`);
          if (itemView) {
            const {offsetTop} = itemView;
            window.scrollTo({top: offsetTop - 100, behavior: 'smooth'});
          }
        }, 500);
      }
    }
  }, [id]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setDataSlug(entryData ?? {});
  }, [entryData]);

  /**
   * use to map data if sections exist in Game
   */
  let ScrollingRelatedGamesContainer = {};
  let KeyFeatureContainer = {};
  let GameDetailCharacter = {};
  let CollectorCardContainer = {};
  let MediaGalleryContainer = {};

  detailData?.data?.gameCollection?.items?.[0]?.sectionCollection?.items.map((section: any) => {
    if (section?.blocksCollection?.items[0]) {
      section.blocksCollection.items[0] = {
        ...section?.blocksCollection.items[0],
        dataTranslation: dataTranslation,
      };
    }
    if (section?.blocksCollection?.items[0]?.type === 'ScrollingRelatedGamesContainer') {
      ScrollingRelatedGamesContainer = {
        ...section,
        blocksCollection: {
          items: [
            {
              classSection: 'thumbnail-card-carousel',
              title: section?.blocksCollection?.items[0]?.title,
              viewMore: {
                title: section?.blocksCollection?.items?.[0]?.seeAllSlug ?? '',
                href: section?.blocksCollection?.items?.[0]?.seeAllText ?? '',
                target: section?.blocksCollection?.items?.[0]?.openNewTab ? '_blank' : '_parent',
              },
              listThumbnail: section?.blocksCollection.items?.[0]?.listGamesCollection?.items,
              __typename: 'ScrollingRelatedGamesContainer',
              id: 'you-may-features-games-detail',
            },
          ],
        },
        id: 'you-may-features-games-detail',
      };
    }
    if (section?.blocksCollection?.items[0]?.__typename === 'GameKeyFeatures') {
      KeyFeatureContainer = {
        ...section,
        blocksCollection: {
          items: [
            {
              onlyShowKeyFeatureCard: section?.blocksCollection?.items?.[0]?.isAaaGame
                ? false
                : true,
              title: section?.blocksCollection?.items[0]?.title ?? '',
              dataComplexKeyFeatureCard:
                section?.blocksCollection?.items[0]?.keyFeatureContainerCollection?.items.find(
                  (item: Types.KeyFeatureMultipleImagesWithDescription) =>
                    item.__typename === 'KeyFeatureMultipleImagesWithDescription'
                ) || {},
              dataKeyFeatureCard:
                section?.blocksCollection?.items[0]?.keyFeatureContainerCollection?.items.filter(
                  (item: Types.KeyFeature) => item.__typename === 'KeyFeature'
                ),
              __typename: 'KeyFeatureContainer',
              id: 'key-features-games-detail',
            },
          ],
        },
        id: 'key-features-games-detail',
      };
    }
    if (section?.blocksCollection?.items[0]?.__typename === 'GameCharacterList') {
      GameDetailCharacter = {
        ...section,
        blocksCollection: {
          items: [
            {
              title: section?.blocksCollection?.items?.[0]?.title,
              characterDetailList:
                section?.blocksCollection?.items?.[0]?.listOfCharactersCollection?.items,
              __typename: 'GameDetailCharacter',
              id: 'characters-features-games-detail',
            },
          ],
        },
        id: 'characters-features-games-detail',
      };
    }
    if (section?.blocksCollection?.items[0]?.__typename === 'GameForCollectors') {
      CollectorCardContainer = {
        ...section,
        blocksCollection: {
          items: [
            {
              __typename: 'CollectorCardContainer',
              title: section?.blocksCollection?.items[0]?.title,
              slugGame: detailItem?.slug ?? '/',
              fromText: dataTranslation['product-from'],
              dataCollectorCard: section?.blocksCollection?.items?.[0]?.collectionsCollection.items,
              id: 'free-collectors-features-games-detail',
              isComingSoon: detailItem?.comingSoon,
              // {
              // label: detailItem?.comingSoon ? dataTranslation['coming-soon'] : '',
              //   label: '',
              // },
              bcProductReference: bcProductReference,
              dataTranslation,
            },
          ],
        },
        id: 'free-collectors-features-games-detail',
      };
    }
    if (section?.blocksCollection?.items[0]?.__typename === 'MediaGallery') {
      MediaGalleryContainer = section?.blocksCollection?.items?.[0]?.isAaAgame
        ? {
            ...section,
            title: section?.blocksCollection?.items[0]?.title,
            sectionWrapperStyles: {
              '& > div': {
                margin: '0px !important',
              },
            },
            blocksCollection: {
              items: [
                {
                  __typename: 'ScrollingMediaGalleryContainer',
                  title: section?.blocksCollection?.items[0]?.title,
                  dataTranslation: dataTranslation,
                  listThumbnail:
                    section?.blocksCollection?.items?.[0]?.videoTrailersCollection?.items,
                  id: 'media-gallery-features-games-detail',
                },
                {
                  __typename: 'HorizontalScrollingContainerMediaGallery',
                  screenshotsCollection:
                    section?.blocksCollection?.items?.[0]?.screenshotsCollection,
                  id: 'media-gallery-features-games-detail',
                },
              ],
            },
            id: 'media-gallery-features-games-detail',
          }
        : {
            ...section,
            title: section?.blocksCollection?.items[0]?.title,
            blocksCollection: {
              items: [
                {
                  __typename: 'MediaGalleryContainer',
                  title: section?.blocksCollection?.items[0]?.title,
                  id: 'media-gallery-features-games-detail',
                  dataTranslation: dataTranslation,
                  listThumbnail: [
                    {
                      id: 1,
                      title: section?.blocksCollection?.items[0]?.title,
                      mediaGalleryCard:
                        section?.blocksCollection?.items?.[0]?.videoTrailersCollection?.items,
                    },
                    {
                      id: 2,
                      title: section?.blocksCollection?.items[0]?.title,
                      mediaGalleryCard:
                        section?.blocksCollection?.items?.[0]?.screenshotsCollection?.items,
                    },
                  ],
                },
              ],
            },
            id: 'media-gallery-features-games-detail',
          };
    }
  });
  const thumbnailImageUrl = detailItem?.mainThumbnailImg?.media?.url
    ? detailItem?.mainThumbnailImg?.media?.url
    : null;
  const SeoStandard = {
    __typename: 'SeoStandard',
    seoTitle: detailItem?.title,
    seoDescription: detailItem?.description,
    seoRobots: null,
    seoImage: thumbnailImageUrl,
    ogTitle: detailItem?.title,
    ogDescription: detailItem?.description,
    ogImage: thumbnailImageUrl,
    seoKeywords: detailItem?.genre,
    seoAuthor: detailItem?.developer,
    seoPublisher: 'Bandai Namco Entertainment Asia',
  };

  const GameDetailMasthead = {
    __typename: 'Section',
    noPadding: true,
    internalName: 'game|game-detail-masthead',
    blocksCollection: {
      items: [
        {
          __typename: 'GameDetailMasthead',
          bcProductReference: bcProductReference,
          mastheadTitle: detailItem?.title ?? '',
          mastheadBgAsset: detailItem?.mastheadBackgroundImage?.media?.url ?? undefined,
          mastheadBgEmbed: detailItem?.mastheadBackgroundImage?.videoEmbed,
          videoType: handleReturnTypeVideo(
            detailItem?.mastheadBackgroundImage?.videoEmbed as string
          ),
          mediaFile: detailItem?.mastheadBackgroundImage?.mediaFile?.url ?? '',
          mastheadDesc: detailItem?.description ?? '',
          platforms: detailItem?.platform ?? '',
          ipPublisher: detailItem?.developer ?? '',
          fromPricing: '',
          price: '',
          currency: '',
          ctaButtonText: '',
          //  isProductReferenceAvaliable
          //   ? dataTranslation['product-buy']
          //   : detailItem?.mastheadGalleryCollection?.items?.length > 0
          //   ? dataTranslation['game-detailed-watch-trailer']
          //   : '',
          slugGame: detailItem?.slug ?? '/',
          isComingSoon: {
            label: detailItem?.comingSoon ? dataTranslation['coming-soon'] : '',
          },
          trailers:
            detailItem?.mastheadGalleryCollection?.items?.map((item: any) => {
              return {
                nextImage: (
                  <RenderNextImage
                    layout="fill"
                    src={
                      handleReturnImg(item?.videoEmbed as string, item) ??
                      item?.media?.url ??
                      PLACEHOLDER_IMG
                    }
                    alt={item?.alt || ''}
                  />
                ),
                trailerUrl: handleReturnIDVideo(item?.videoEmbed as string) ?? '',
                trailerTitle: item?.caption ?? '',
                thumbnailImg:
                  handleReturnImg(item?.videoEmbed as string, item) ??
                  item?.media?.url ??
                  PLACEHOLDER_IMG,
                videoType: handleReturnTypeVideo(item?.videoEmbed as string) ?? '',
              };
            }) || [],
          dataTranslation,
          orderGames,
        },
      ],
    },
  };

  const Updatebar = listUpdateBarNews?.items?.length
    ? {
        __typename: 'Section',
        noPadding: true,
        sectionWrapperStyles: {
          backgroundColor: '#F9F9F9',
        },
        blocksCollection: {
          items: [
            {
              __typename: 'GamesListing',
              type: 'UpdateBar',
              title: dataTranslation['filter-news-game-updates'],
              events: listUpdateBarNews?.items?.map((item: any) => {
                return {
                  title: item.title,
                  date: handleReturnDateForLocal(
                    locale,
                    `${item.publishDate}`.substring(0, 10),
                    true
                  ),
                };
              }),
              viewMore: {
                title: dataTranslation['update-bar-see-more'],
                href: '/',
                target: '_parent',
              },
            },
          ],
        },
      }
    : {};
  const SubNavigationBar: any = {
    __typename: 'Section',
    noPadding: true,
    internalName: 'game|sub-navigation-bar',
    blocksCollection: {
      items: [
        {
          __typename: 'GamesListing',
          type: 'SubNavigationBar',
          listNavigation: listSubNavigationBar || [],
          variant: 'dropdown',
          onBuy: () => {},
          onSelectItem: () => {},
          listItemRender: [],
          slugGame: detailItem?.slug ?? '/',
          isComingSoon: {
            label: detailItem?.comingSoon ? dataTranslation['coming-soon'] : '',
          },
          bcProductReference: bcProductReference,
          dataTranslation,
        },
      ],
    },
  };

  const GameShortDescription = (detailItem?.overviewTitle || detailItem?.overviewDescription) && {
    __typename: 'Section',
    noPadding: true,
    internalName: 'game|game-short-description',
    blocksCollection: {
      items: [
        {
          ...detailItem,
          __typename: 'GamesListing',
          type: 'GameShortDescription',
          noPadding: true,
          variant: 'vertical',
          id: 'overview-games-detail',
        },
      ],
    },
    id: 'overview-games-detail',
  };

  const handleCheckRemoveITem = (dataPlatform: string[]) => {
    const platformNew: string[] = [];
    !!dataPlatform.length &&
      dataPlatform.map((item: string) => {
        if (item !== 'XBOX Series X' && item !== 'Nintendo 3DS' && item !== 'Nintendo 3DS XL') {
          platformNew.push(item);
        }
      });
    return platformNew?.join(', ') ?? '';
  };

  const GameDetailInformation = {
    __typename: 'Section',
    noPadding: false,
    internalName: 'game|game-detail-information',
    blocksCollection: {
      items: [
        {
          __typename: 'GameDetailInformation',
          copyRight: detailItem.copyRight ?? '',
          id: 'information-games-detail',
          listProps: [
            {
              id: 1,
              title: dataTranslation['game-detailed-game-info-release-date'],
              detail: detailItem?.releaseDate
                ? handleReturnDateForLocal(
                    locale || '',
                    `${detailItem?.releaseDate}`.substring(0, 10)
                  )
                : `${locale}`.toLowerCase().includes('tc')
                ? '未定'
                : `${locale}`.toLowerCase().includes('sc')
                ? '未定'
                : `${locale}`.toLowerCase().includes('ko')
                ? '미정'
                : 'To be announced',
            },
            {
              id: 2,
              title: dataTranslation['game-detailed-game-info-release-developer'],
              detail: detailItem?.developer,
            },
            {
              id: 3,
              title: dataTranslation['game-detailed-game-info-release-genre'],
              detail:
                handleTranslateGameGenres(detailItem?.genre, dataTranslation)?.join(', ') ?? '',
            },
            {
              id: 4,
              title: dataTranslation['game-detailed-game-info-release-platform'],
              detail: handleCheckRemoveITem(detailItem?.platform ?? []),
            },
            {
              id: 5,
              title: dataTranslation['game-detailed-game-info-release-subtitle'],
              detail:
                handleTranslateGameLanauges(detailItem?.subtitle, dataTranslation)?.join(', ') ??
                '',
            },
            {
              id: 6,
              title: dataTranslation['game-detailed-game-info-release-audio'],
              detail:
                handleTranslateGameLanauges(detailItem?.audio, dataTranslation)?.join(', ') ?? '',
            },
          ],
        },
      ],
    },
    id: 'information-games-detail',
  };

  // const HorizontalScrollingEditionContainer = !!detailData.data.gameCollection.items?.[0]
  //   ?.gameEditionsCollection?.items?.length && {
  //   __typename: 'Section',
  //   noPadding: false,
  //   internalName: 'game|horizontal-scrolling-container',
  //   blocksCollection: {
  //     items: [
  //       {
  //         __typename: 'HorizontalScrollingContainer',
  //         title: detailData.data.gameCollection.items[0]?.title,
  //         classSection: 'horizontal-scrolling-container',
  //         listThumbnail: detailData.data.gameCollection.items[0].gameEditionsCollection.items ?? [],
  //         listTagsColor: listTagsColor,
  //         slugGame: detailItem?.slug ?? '/',
  //         id: 'editions-features-games-detail',
  //       },
  //     ],
  //   },
  //   id: 'editions-features-games-detail',
  // };

  // const ScrollingDLCContainer = !!listNewsDLCcard.length && {
  //   __typename: 'Section',
  //   noPadding: false,
  //   internalName: 'game|scrolling-dlc-container',
  //   blocksCollection: {
  //     items: [
  //       {
  //         __typename: 'ScrollingDLCContainer',
  //         title: 'Downloadable content (DLC)',
  //         classSection: 'thumbnail-card-carousel',
  //         listThumbnail: listNewsDLCcard,
  //         dataTranslation: dataTranslation,
  //         id: 'dlc-features-games-detail',
  //       },
  //     ],
  //   },
  //   id: 'dlc-features-games-detail',
  // };
  const ScrollingFreeCollectiblesContainer = !!listFreeCollectibles?.items?.length && {
    __typename: 'Section',
    noPadding: false,
    internalName: 'game|scrolling-free-collectibles-container',
    blocksCollection: {
      items: [
        {
          __typename: 'ScrollingFreeCollectiblesContainer',
          title: dataTranslation['game-detailed-sub-nav-free-collectibles'],
          classSection: 'thumbnail-card-carousel',
          listThumbnail: listFreeCollectibles.items,
          id: 'free-collectibles-features-games-detail',
          dataTranslation,
        },
      ],
    },
    id: 'free-collectibles-features-games-detail',
    bcProductReference: bcProductReference,
  };

  const GameSuggestionsCard = !!detailItem &&
    bcProductReference?.title && {
      __typename: 'Section',
      noPadding: false,
      internalName: 'game|game-suggestions-card',
      sectionWrapperStyles: {
        backgroundColor: '#F9F9F9',
      },
      blocksCollection: {
        items: [
          {
            ...bcProductReference?.site?.product,
            __typename: 'GameSuggestionsCard',
            bcProductReference,
            name:
              detailData?.data?.gameCollection?.items[0]?.title ??
              bcProductReference?.site?.product?.name,
            dataTranslation: dataTranslation,
            platform: detailData?.data?.gameCollection?.items?.[0]?.platform ?? [],
            gamesFilterThumbnailImage:
              detailData?.data?.gameCollection?.items[0]?.gamesFilterThumbnailImage?.media?.url ??
              detailData?.data?.gameCollection?.items[0]?.filterIcon262X160?.media?.url ??
              PLACEHOLDER_IMG,
            slugGame: detailItem?.slug ?? '/',
            isComingSoon: {
              label: detailItem?.comingSoon ? dataTranslation['coming-soon'] : '',
            },
            id: 'suggestions-features-games-detail',
          },
        ],
      },
      id: 'suggestions-features-games-detail',
    };

  const ExploreMoreContainer = (!!listLatestNews?.items?.length ||
    !!listPatchNotes?.items?.length) && {
    __typename: 'Section',
    noPadding: false,
    internalName: 'game|explore-more-container',
    blocksCollection: {
      items: [
        {
          listLatestNews: {
            ...listLatestNews,
            items: handleTranslateNews(listLatestNews.items, dataTranslation),
          },
          listPatchNotes: {
            ...listPatchNotes,
            items: handleTranslateNews(listPatchNotes.items, dataTranslation),
          },
          listTags: listTagsColor,
          dataTranslation: dataTranslation,
          detailGame: detailItem,
          title: dataTranslation['game-detailed-explore-more-title'],
          __typename: 'ExploreMoreContainer',
          id: 'explore-more-features-games-detail',
        },
      ],
    },
    id: 'explore-more-features-games-detail',
  };

  const AdsContainer = dataAdsContainer?.title
    ? {
        __typename: 'Section',
        noPadding: true,
        internalName: 'game|ads-container',
        blocksCollection: {
          items: [
            {
              __typename: 'AdsContainer',
              ...dataAdsContainer,
              href: `/${locale}${dataAdsContainer?.href}`,
              id: 'features-games-detail',
            },
          ],
        },
        id: 'features-games-detail',
      }
    : null;

  const PoliciesAndNotes = {
    __typename: 'Section',
    noPadding: false,
    internalName: 'game|policies-and-notes',
    sectionWrapperStyles: {
      backgroundColor: '#F9F9F9',
    },
    blocksCollection: {
      items: [{...dataPoliciesAndNotes, __typename: 'PoliciesAndNotes'}],
    },
  };

  const AgeRatingPopup = {
    __typename: detailData?.data?.gameCollection?.items?.[0].restrictAge ? 'AgeRatingPopup' : '',
    title: dataTranslation['game-restricted-age-title'] ?? '',
    description: dataTranslation['game-restricted-age-description'] ?? '',
    atLeastAgeLabel: dataTranslation['game-restricted-age-at-least-age-label'] ?? '',
    notYetAgeLabel: dataTranslation['game-restricted-age-not-yet-age-label'] ?? '',
    isOpen: detailData?.data?.gameCollection?.items?.[0].restrictAge ?? false,
  };

  // const subscribe = {
  //   __typename: 'SubscribePopup',
  // };

  // Web Launch Comment
  const block: Array<any> =
    locale === 'sea' || locale === 'ko-kr'
      ? [
          SeoStandard,
          GameDetailMasthead,
          Updatebar,
          SubNavigationBar,
          GameShortDescription,
          GameDetailInformation,
          KeyFeatureContainer,
          GameDetailCharacter,
          //HorizontalScrollingEditionContainer, - Web launch comment
          CollectorCardContainer,
          //ScrollingDLCContainer,  - Web launch comment
          MediaGalleryContainer,
          ScrollingFreeCollectiblesContainer,
          GameSuggestionsCard,
          ExploreMoreContainer,
          ScrollingRelatedGamesContainer,
          //AdsContainer, - Web launch comment
          PoliciesAndNotes,
          AgeRatingPopup,
        ].filter(block => !!block)
      : [
          SeoStandard,
          GameDetailMasthead,
          Updatebar,
          SubNavigationBar,
          GameShortDescription,
          GameDetailInformation,
          KeyFeatureContainer,
          GameDetailCharacter,
          //HorizontalScrollingEditionContainer, - Web launch comment
          //CollectorCardContainer,  - Web launch comment
          //ScrollingDLCContainer,  - Web launch comment
          MediaGalleryContainer,
          ScrollingFreeCollectiblesContainer,
          GameSuggestionsCard,
          ExploreMoreContainer,
          ScrollingRelatedGamesContainer,
          //AdsContainer, - Web launch comment
          PoliciesAndNotes,
          AgeRatingPopup,
        ].filter(block => !!block);
  SubNavigationBar.blocksCollection.items[0].listItemRender = [...block];

  // useEffect(() => {
  //   window.addEventListener('touchstart', touchStart);
  //   window.addEventListener('touchmove', preventTouch, {passive: false});
  //   return () => {
  //     window.removeEventListener('touchstart', touchStart);
  //     window.removeEventListener('touchmove', preventTouch);
  //   };
  // }, []);

  // set color component alternate;

  const newBlock = useMemo(() => {
    let index = 0;
    return block.map((item: any) => {
      if (
        item?.internalName === 'game|game-detail-masthead' ||
        item?.internalName === 'game|sub-navigation-bar' ||
        item?.internalName === 'game|game-short-description' ||
        item?.internalName === 'game|game-detail-information'
      ) {
        return item;
      }
      if (item?.__typename === 'Section' && item?.internalName) {
        if (index % 2 === 0) {
          index += 1;
          return {
            ...item,
            theme: {__typename: 'Theme', name: 'Grey', codeId: '#fff'},
            sectionWrapperStyles: {backgroundColor: '#fff'},
          };
        } else {
          index += 1;
          return {
            ...item,
            theme: {__typename: 'Theme', name: 'Grey', codeId: '#f9f9f9'},
            sectionWrapperStyles: {backgroundColor: '#f9f9f9'},
          };
        }
      } else {
        return item;
      }
    });
  }, [block]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <BlockRenderer block={[...newBlock]} />
    </Box>
  );
};

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const slug = String(ctx?.params?.slug ?? '/');
  //TODO: TO remove this hack
  if (`${slug}`.toLowerCase() === 'digimon-world-next-order') {
    return {
      redirect: {
        destination: `/${ctx.locale}/games/digimon-world:-next-order`,
        permanent: false,
      },
    };
  }
  if (`${slug}`.toLowerCase() === 'doraemon-story-of-seasons-friends-of-the-great-kingdom') {
    return {
      redirect: {
        destination: `/${ctx.locale}/games/doraemon-story-of-seasons:-friends-of-the-great-kingdom`,
        permanent: false,
      },
    };
  }
  if (`${slug}`.toLowerCase() === 'jojos-bizarre-adventure-all-star-battle-r' && (ctx.locale)?.toLowerCase() !=='ko-kr') {
    return {
      redirect: {
        destination: `/${ctx.locale}/games/jojo's-bizarre-adventure:-all_star-battle-r`,
        permanent: false,
      },
    };
  }

  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);
  ctx.res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=120');
  const locale: string = handleConvertToLocaleContentful(ctx?.locale as string) ?? '';
  const promises: [
    ReturnType<typeof getDataRefBySlug>,
    ReturnType<typeof getPageData>,
    ReturnType<typeof getListOtherGamesLanguages>,
    ReturnType<typeof getListNews>,
    ReturnType<typeof getListNews>,
    ReturnType<typeof getListNews>,
    // ReturnType<typeof getListNews>,
    ReturnType<typeof getListNews>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>
  ] = [
    getDataRefBySlug({slug: slug, preview}, ctx, PAGE_TYPE.Games),
    getPageData({slug: 'games', preview}, ctx),
    getListOtherGamesLanguages({slug: `${slug}`, preview}),
    getListNews(locale, ['Patch notes'], 6, 'publishDate_DESC', 0, slug, undefined, false),
    getListNews(locale, [], 5, 'publishDate_DESC', 0, slug),
    getListNews(locale, [], 6, 'publishDate_DESC', 0, slug, undefined, true),
    // getListNews(locale, ['DLC'], 10, 'publishDate_DESC', 0, slug),
    getListNews(locale, ['Downloads'], 10, 'publishDate_DESC', 0, slug),
    getGloablByType(locale, GLOBAL_TYPE.adsContainer),
    getGloablByType(locale, GLOBAL_TYPE.policiesAndNotes),
    getGloablByType(locale, GLOBAL_TYPE.subNavigationBar),
  ];
  const [
    detailData,
    dataPage,
    otherGamesLanguages,
    listPatchNotes,
    listUpdateBarNews,
    listLatestNews,
    // listNewsDLCtag,
    listFreeCollectibles,
    dataAdsContainer,
    dataPoliciesAndNotes,
    listSubNavigationBar,
  ] = await Promise.all(promises);
  const {data} = dataPage;
  const pageDetailData = detailData?.data as GetGamesQueryDetailQuery;
  const codeProductReference = pageDetailData.gameCollection?.items[0]?.bcProductReference || '';
  // const bcProductReference = await getPriceGame(codeProductReference, locale);
  // const length = listNewsDLCtag?.items?.length;
  // const listNewsDLCcard: any[] = [];

  // if (length) {
  //   for (let i = 0; i < length; i += 1) {
  //     const item = listNewsDLCtag?.items[i];
  //     const bcP = item?.game?.bcProductReference ?? 'DBF';
  //     const bcProductReferenceDLC = await getPriceGame(bcP, '');
  //     listNewsDLCcard.push({
  //       ...listNewsDLCtag?.items[i],
  //       bcProductReferenceDLC,
  //     });
  //   }
  // }
  const currencyCode = ['tw-tc', 'tw-sc'].includes(`${ctx?.locale}`.toLowerCase())
    ? 'TWD'
    : ['hk-tc', 'hk-sc'].includes(`${ctx?.locale}`.toLowerCase())
    ? 'HKD'
    : ['ko-kr'].includes(`${ctx?.locale}`.toLowerCase())
    ? 'KRW'
    : 'SGD';
  const bcProductReference = await handleGetProductDetail(
    codeProductReference,
    locale,
    currencyCode as string
  );

  const detailItem = pageDetailData?.gameCollection?.items[0];
  const entryData =
    detailItem &&
    (await client(
      process.env.NEXT_PUBLIC_CF_SPACE_ID as string,
      process.env.NEXT_PUBLIC_CF_DELIVERY_ACCESS_TOKEN as string
    ).getEntry(pageDetailData?.gameCollection?.items[0]?.sys?.id ?? '', {
      locale: '*',
    }));
  if (!detailItem) {
    return {
      redirect: {
        destination: `/${ctx.locale}/404`,
        permanent: false,
      },
    };
  } else {
    return {
      props: {
        data,
        locale: (ctx?.locale?.toLocaleLowerCase() as string) ?? '',
        detailData,
        listPatchNotes,
        listUpdateBarNews,
        listLatestNews,
        // listNewsDLCcard,
        listFreeCollectibles,
        dataAdsContainer: dataAdsContainer,
        dataPoliciesAndNotes: dataPoliciesAndNotes,
        bcProductReference,
        // codeProductReference,
        listSubNavigationBar: listSubNavigationBar,
        entryData: entryData?.fields?.slug ?? {},
        orderGames: otherGamesLanguages,
      },
    };
  }
};

export default GamesDetail;
